import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isNative } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var description = _ref.description,
    designContext = _ref.designContext,
    disabled = _ref.disabled,
    inline = _ref.inline,
    warning = _ref.warning;
  return {
    rootStyle: _objectSpread({}, inline ? {
      alignItems: 'center',
      height: description != null ? 100 : 70,
      width: '100%',
      paddingLeft: inline ? 20 : 0,
      paddingRight: inline ? 20 : 0
    } : {
      position: 'relative',
      height: 60,
      width: 320
    }),
    inlineModeWrapperStyle: {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: isNative ? 'stretch' : 'baseline'
    },
    iconBackWrapperStyle: {
      position: 'absolute',
      left: 30,
      top: 20
    },
    iconForwardWrapperStyle: {
      position: 'absolute',
      right: 30,
      top: 20
    },
    inlineIconBackWrapperStyle: {
      width: 25,
      height: 20,
      paddingTop: 20,
      paddingRight: 5
    },
    inlineIconForwardWrapperStyle: {
      width: 25,
      height: 20,
      paddingTop: 20,
      paddingLeft: 5
    },
    paragraphSecondaryCorrectFootprintCenteredStyle: _objectSpread(_objectSpread({
      color: designContext.get('date-picker/text-color', {
        role: warning ? 'warning' : 'default',
        interactiveState: disabled && !warning ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('text-style/text/labels/body/regular').styles()), {}, {
      lineHeight: 25,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'center',
      wordBreak: 'break-word',
      marginBottom: -10,
      marginTop: -10,
      paddingBottom: 3,
      paddingTop: 2
    }),
    titleSecondaryWrapperStyle: {
      paddingTop: 21,
      paddingBottom: 21
    },
    titlePrimarySmallStyle: _objectSpread(_objectSpread({
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
      boxSizing: 'border-box',
      flexShrink: 0,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      textAlign: 'left'
    }, designContext.get('text-style/text/labels/tall/bold').styles()), {}, {
      fontSize: 27,
      lineHeight: 30,
      color: designContext.get('date-picker/text-color', {
        role: 'month'
      }).toString(),
      marginBottom: -10,
      marginTop: -5,
      paddingTop: 1,
      paddingBottom: 4,
      backgroundColor: undefined
    }),
    titleSecondaryStyle: _objectSpread(_objectSpread({
      color: designContext.get('date-picker/text-color', {
        role: 'month'
      }).toString()
    }, designContext.get('text-style/text/labels/tall/bold').styles()), {}, {
      fontSize: 19,
      lineHeight: 25,
      textAlign: 'center',
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      marginBottom: -10,
      marginTop: -5,
      paddingBottom: 4,
      paddingTop: 1
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map